<template>
  <div class="page_layout clearfix">
    <app-header :isPageLayer="true">
      <h1 class="logo" slot="extra">
        <router-link :to="{ name: 'home' }">
          <i class="icon icon--logo-new"></i>
        </router-link>
      </h1>
    </app-header>
    <router-view class="content"/>
  </div>
</template>

<script>
import AppHeader from '@/components/header'
export default {
  name: 'PageLayout',
  components: {
    AppHeader
  }
}
</script>

<style lang="scss" scoped>
.page_layout {
  .logo {
    margin-left: 15px;
  }
  /deep/ .btn__area {
    right: 15px;
  }
}
</style>
